interface CardItem {
  image: string;
  tag: string;
  title: string;
  desc: string;
  meta: string;
}

const cardItems: CardItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20with%20microphone%20and%20spotlight%2C%20warm%20red%20and%20gold%20tones%2C%20breaking%20news%20concept%2C%20editorial%20photography%20style%2C%20dramatic%20lighting%2C%20clean%20modern%20composition%2C%20no%20text%2C%20professional%20studio%20setup&width=800&height=500&seq=card-01-2026&orientation=landscape',
    tag: '深度扒皮',
    title: '某小花旦真实年龄成谜？多方证据指向年龄造假',
    desc: '近日有网友扒出某当红小花旦的多份公开资料年龄不一致，从学籍信息到早年综艺片段均存在疑点，引发全网热议。',
    meta: '8.2万阅读 · 3小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20paparazzi%20cameras%20flashing%2C%20celebrity%20entrance%20concept%2C%20warm%20golden%20lighting%2C%20glamorous%20atmosphere%2C%20editorial%20style%2C%20elegant%20composition%2C%20no%20text&width=800&height=500&seq=card-02-2026&orientation=landscape',
    tag: '独家爆料',
    title: '年度大戏：两大流量小生后台互撕全程还原',
    desc: '某颁奖典礼后台发生严重冲突，两位当红流量小生因番位之争当场翻脸，工作人员还原全过程细节惊人。',
    meta: '12.6万阅读 · 1小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20feed%20on%20smartphone%20screen%20showing%20trending%20topics%2C%20warm%20ambient%20lighting%2C%20modern%20digital%20lifestyle%20concept%2C%20clean%20editorial%20style%2C%20no%20text%2C%20soft%20shadows&width=800&height=500&seq=card-03-2026&orientation=landscape',
    tag: '热搜追踪',
    title: '某综艺选手被曝学历造假，节目组连夜删减镜头',
    desc: '一档热门选秀节目选手被质疑学历造假后，节目组紧急对其镜头进行大幅删减，该选手排名已跌出出道位。',
    meta: '9.7万阅读 · 5小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20directors%20chair%20and%20camera%20equipment%2C%20warm%20cinematic%20lighting%2C%20movie%20production%20concept%2C%20editorial%20style%2C%20dramatic%20composition%2C%20no%20text&width=800&height=500&seq=card-04-2026&orientation=landscape',
    tag: '片场揭秘',
    title: '大制作剧组内部矛盾曝光，男女主角全程无交流',
    desc: '投资过亿的古装大剧拍摄现场气氛诡异，男女主角从开机至今零互动，知情人透露双方团队矛盾已久。',
    meta: '6.8万阅读 · 8小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20ring%20light%20and%20products%20on%20display%2C%20ecommerce%20concept%2C%20warm%20modern%20aesthetic%2C%20clean%20editorial%20composition%2C%20no%20text%2C%20soft%20ambient%20light&width=800&height=500&seq=card-05-2026&orientation=landscape',
    tag: '翻车现场',
    title: '头部主播带货翻车后续：品牌方全面解约索赔',
    desc: '此前因虚假宣传翻车的某头部带货主播再遭打击，多家合作品牌宣布终止合作并提出巨额索赔。',
    meta: '15.4万阅读 · 30分钟前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20colorful%20lighting%20and%20empty%20seats%2C%20music%20performance%20concept%2C%20warm%20dramatic%20atmosphere%2C%20editorial%20style%2C%20grand%20composition%2C%20no%20text&width=800&height=500&seq=card-06-2026&orientation=landscape',
    tag: '行业震荡',
    title: '演唱会市场大洗牌：多位歌手宣布取消巡演计划',
    desc: '受多重因素影响，今年下半年已有十余位知名歌手宣布取消或推迟巡回演唱会，行业面临严峻考验。',
    meta: '5.3万阅读 · 6小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20entertainment%20news%20studio%20with%20kpop%20elements%2C%20vibrant%20colorful%20aesthetic%2C%20idol%20concept%2C%20warm%20editorial%20style%2C%20clean%20composition%2C%20no%20text%2C%20modern%20asian%20design&width=800&height=500&seq=card-07-2026&orientation=landscape',
    tag: '韩娱速递',
    title: '韩娱大地震：知名经纪公司被曝系统性压榨练习生',
    desc: '韩国某头部经纪公司被前练习生联名举报，揭露其长期存在的不合理合同、过劳训练及薪资克扣等问题。',
    meta: '11.1万阅读 · 4小时前',
  },
];

const SectionCards = () => (
  <section id="cards" className="py-16 md:py-20 bg-background-50">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">图文资讯</h2>
        <p className="mt-2 text-sm text-foreground-500">深度扒皮，还原娱乐事件真相</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {cardItems.map((item) => (
          <article key={item.title} className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer">
            <div className="relative overflow-hidden h-48 md:h-52">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                {item.tag}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              <p className="mt-3 text-xs text-foreground-400">{item.meta}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default SectionCards;